(function () {
    'use strict';

    angular
        .module('invesfleet')
        .directive('autocombo', autocombo);

    autocombo.$inject = ['$filter', '$timeout', 'modals', '$state', '$compile', 'common'];

    /* USAGE:
    <div autocombo
        data="vm.list"                          //Binding to the item list
        ng-model="vm.selected"                  //Binding to the selected item

        ng-change="vm.onChange()"               //OPTIONAL - Callback function 
        ng-disable="true"                       //OPTIONAL - Disabled expression
        label-text="Autocombo"                  //OPTIONAL - Label text
        id-field="id"                           //OPTIONAL - ID field
        display-field="display"                 //OPTIONAL - Description field
        display-id-field="displayId"            //OPTIONAL - Display ID field
        strict="false"                          //OPTIONAL - Allow freeform input
        empty-text="No hay elementos"           //OPTIONAL - Text for the 'no items found' message
        is-loading="loading"                    //OPTIONAL - Expression to display the loading message
        loading-text="Cargando..."              //OPTIONAL - Text for the message while loading the data (list == null)
        placeholder="Escribe aqui..."           //OPTIONAL - Placeholder text

        entity-create="entity"                  //OPTIONAL - Identifier for the modal service
        entity-create-callback="onCreate()"     //OPTIONAL - Callback function for the creation modal
        entity-edit="entity"                    //OPTIONAL - Identifier for the modal service
        entity-edit-callback="onEdit()"         //OPTIONAL - Callback function for the edition modal
        entity-link="entity"                    //OPTIONAL - State to transition to (with parameter "id")

        bloodhound="bloodhound"                 //OPTIONAL - Bloodhound engine in the view model
        limit="10"                              //OPTIONAL - limit of results that will be show
        helperDisplayField="prdesc"             //OPTIONAL - used for "cities" for shows your province
    >
    </div>
    */

    function autocombo($filter, $timeout, modals, $state, $compile, common) {
        
        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/views/directives/autocombo.html',
            scope: {
                data: '=', //List of elements
                ngModel: '=?', //Item selected
                ngModelId: '=?',
                ngModelValue: '=?',
                idField: '@?', //Default: 'id'
                displayField: '@?', //Default: 'nombre'
                displayIdField: '@?',
                labelText: '@?',
                isLoading: '=?', //Expression to display the loading message
                loadingText: '@?', //Default: 'Cargando datos...'
                emptyText: '@?', //Default: 'No hay elementos'
                ngChange: '&?', //Callback function when ngModel changes
                onChange: '&?',
                ngDisabled: '=?',
                strict: '=?', //Default: true
                placeholder: '@?',
                autofocus: '<',
                defaultOpt: '@?',
                required: '<',
                maxlength: '@?',

                //Entity create/link
                entityLink: '@?', //The final link will be: [entityLink + '?id=' + selectedItemId]
                entityCreate: '@?', //The string referencing the modal on the service
                entityEdit: '@?', //The string referencing the modal on the service
                entityCreateCallback: '&?',
                entityEditCallback: '&?',

                useBloodhound: '=?',
                bloodhound: '=?',
                limit: '@?',
                minLength: '@?',
                inputPrevValue: '@?', // used to avoid search again
                helperDisplayField: '@?',
                id: '@?'
            }
        };
        return directive;

        /* jshint maxstatements:false, maxcomplexity:false */
        function link(scope, element, attrs) {

            scope.isOpen = false;
            scope.hasFocus = false;
            scope.inputText = '';
            scope.idMatchItem = null;
            scope.filteredList = [];
            scope.highlightItem = null;

            if (!scope.idField) { scope.idField = 'id'; }
            if (!scope.displayField) { scope.displayField = 'nombre'; }
            if (!scope.loadingText) { scope.loadingText = 'Cargando datos...'; }
            if (!scope.emptyText) { scope.emptyText = 'No hay elementos'; }
            if (typeof scope.strict === 'undefined') { scope.strict = true; }
            if (!scope.placeholder) { scope.placeholder = ''; }
            if (!scope.defaultOpt) { scope.defaultOpt = null; }
            if (!scope.autofocus) { scope.autofocus = false; } else { scope.autofocus = true; }
            if (!scope.required) { scope.required = false; }
            if (scope.strict || !scope.maxlength) { scope.maxlength = ''; }
            if (scope.limit === null || typeof scope.limit === 'undefined') { scope.limit = 10; }
            if (scope.minLength === null || typeof scope.minLength === 'undefined') { scope.minLength = 2; }
            if (common.isNullOrUndefined(scope.useBloodhound)) { scope.useBloodhound = false; }
            //if(scope.cascadeChild === null || typeof scope.cascadeChild === 'undefined') { scope.cascadeChild = null; }
            //if(scope.cascadeParent === null || typeof scope.cascadeParent === 'undefined') { scope.cascadeParent = null; }

            if (!scope.ngModel) {
                scope.ngModel = {};
                scope.ngModel[scope.idField] = scope.ngModelId;
                scope.ngModel[scope.displayField] = scope.ngModelValue;
            }

            scope.defaultItem = {};
            scope.defaultItem[scope.idField] = null;
            scope.defaultItem[scope.displayField] = scope.defaultOpt;
            scope.defaultItem[scope.displayIdField] = null;

            scope.isSelected = function () {
                if (!scope.ngModel) { return false; }
                if (scope.strict && !scope.ngModel[scope.idField]) { return false; }
                if (!scope.ngModel[scope.displayField]) { return false; }
                return true;
            };

            scope.selectItem = function (item) {
                if (!scope.useBloodhound) {
                    if (scope.defaultOpt && item === scope.defaultItem) {
                        scope.ngModel = {};
                        scope.ngModel[scope.idField] = null;
                        scope.ngModel[scope.displayField] = null;
                        scope.ngModel[scope.displayIdField] = null;
                    } else {
                        scope.ngModel = item;
                        scope.inputText = scope.isSelected() ? scope.ngModel[scope.displayField] : '';
                    }
                } else {
                    scope.ngModel = item;
                    scope.inputText = scope.isSelected() ? scope.ngModel[scope.displayField] : '';
                }
            };
            
            function filterData(newValue, oldValue) {
                
                if (!scope.data) {
                    if (scope.data === [] && scope.ngModelId) {
                        scope.ngModel = scope.emptyItem;
                    }
                    return;
                }

                if (!scope.useBloodhound) {
                    //Filtered data by name
                    if(scope.id == "paisEnt")
                        console.log("entra pero no debería");
                    var filterInfo = { };
                    filterInfo[scope.displayField] = scope.inputText;
                    scope.filteredList = $filter('searchFilter')(scope.data, filterInfo, true);

                    if (scope.defaultOpt) {
                        scope.filteredList.unshift(scope.defaultItem);
                    }

                    //ID exact match
                    scope.idMatchItem = null;
                    if (scope.inputText) {
                        var idMatch = scope.data.filter(
                            function (element) { return element[scope.displayIdField] === scope.inputText; }
                        );
                        if (idMatch.length > 0) { scope.idMatchItem = idMatch[0]; }
                    }

                    //Highlighted item
                    scope.highlightItem = null;
                    if (scope.idMatchItem) {
                        scope.highlightItem = scope.idMatchItem;
                    }
                    else {
                        var nameMatch = scope.filteredList.filter(
                            function (element) {
                                return $filter('cleanFilter')
                                    (element[scope.displayField], null) === $filter('cleanFilter')(scope.inputText, null);
                            }
                        );

                        if (nameMatch.length > 0) { scope.highlightItem = nameMatch[0]; }
                    }

                    if (scope.highlightItem == null && scope.filteredList.length > 0 && scope.inputText !== '') {
                        scope.highlightItem = scope.filteredList[0];
                    }

                    if (scope.ngModelId) {
                        var found = $filter('filter')(scope.data, { [scope.idField]: scope.ngModelId });
                        if (found.length === 0) {
                            scope.ngModel = scope.emptyItem;
                        }
                        else if (found.length === 1) {
                            scope.ngModel = found[0];
                        }
                    }

                } else {
                    if (scope.bloodhound) {
                        if (scope.inputText.length >= scope.minLength) {
                            //if (scope.inputPrevValue !== scope.inputText) {
                            if (true) {
                                //scope.inputPrevValue = scope.inputText;
                                var limit = scope.limit;
                                if (!scope.inputText || scope.inputText == '') {
                                    var end = scope.data.length <= limit ? scope.data.length : limit;
                                    scope.filteredList = scope.data.slice(0, end);
                                } else {
                                    scope.bloodhound.search(scope.inputText, function (res) {
                                        var end = res.length <= limit ? res.length : limit;
                                        scope.filteredList = res.slice(0, end);
                                    });
                                }
                            }
                        }
                    }
                }
            }

            scope.$watch('ngModel',
                function (newSelected, oldSelected) {
                    /* jshint maxcomplexity:false */
                    //If its an entity we show the create/link buttons
                    
                    element.removeClass('add-icon');
                    if (!scope.isSelected()) {
                        if (scope.entityCreate) { element.addClass('add-icon'); }
                    } else {
                        if ((scope.entityEdit || scope.entityLink) && scope.ngModel[scope.idField]) {
                            element.addClass('add-icon');
                        }
                    }

                    //TODO: mostrar el id del seleccionado? 
                    scope.inputText = scope.isSelected() ? scope.ngModel[scope.displayField] : '';

                    if (!common.isNullOrUndefined(newSelected)) {

                        if (!common.isNullOrUndefined(newSelected[scope.idField]))
                            scope.ngModelId = newSelected[scope.idField];
                        else
                            scope.ngModelId = null;

                        if (!common.isNullOrUndefined(newSelected[scope.displayField]))
                            scope.ngModelValue = newSelected[scope.displayField];
                        else
                            scope.ngModelValue = null;
                        
                        //if (scope.id == "paisEnt") {
                        //    console.log(scope.ngModel);
                        //}

                    } else {
                        scope.ngModelId = null;
                        scope.ngModelValue = null;                        
                    }

                    if (scope.ngChange) {
                        if ((newSelected && newSelected[scope.idField]) !== (oldSelected && oldSelected[scope.idField])) {
                            $timeout(function () { scope.ngChange(); }); //Calling ngChange callback
                        }
                    }
                    if (scope.onChange) {
                        if ((newSelected && newSelected[scope.idField]) !== (oldSelected && oldSelected[scope.idField])) {
                            $timeout(function () { scope.onChange(); }); //Calling onChange callback
                        }
                    }
                },
                true
            );

            scope.$watch(
                'ngModelId',
                function (newSelected, oldSelected) {
                    if (common.isNullOrUndefined(newSelected)) { return; }
                    else if (!scope.ngModel || scope.ngModel[scope.idField] !== newSelected) {
                        var found = $filter('filter')(scope.data, { [scope.idField]: scope.ngModelId });
                        if (found && found.length > 0) {
                            scope.ngModel = found[0];
                        }
                    }
                },
                true
            );

            scope.$watch(
                'ngModelValue',
                function (newSelected, oldSelected) {
                    if (!scope.ngModel || newSelected !== scope.ngModel[scope.displayField]) {
                        scope.ngModel = { [scope.displayField]: scope.ngModelValue };
                    }
                },
                true
            );

            /**
             * Watch inputText changes to:
             *  - Filter the list with the inputText
             */
            scope.$watch('inputText',
                filterData
            );

            scope.$watch('data.length',
                filterData
            );

            element.find('input').on('blur',
                function (evt) {
                    if (!scope.useBloodhound) {
                        if (scope.highlightItem) { scope.selectItem(scope.highlightItem); }
                        else {
                            var o = {};
                            o[scope.idField] = null;
                            o[scope.displayIdField] = null;
                            if (scope.strict) {
                                o[scope.displayField] = null;
                                scope.selectItem(o);
                            } else {
                                o[scope.displayField] = scope.inputText;
                                scope.selectItem(o);
                            }
                        }

                        scope.highlightItem = null;
                        scope.isOpen = false;
                        scope.hasFocus = false;
                        scope.$apply();
                    } else {
                        setTimeout(function () {
                            scope.isOpen = false;
                            scope.hasFocus = false;
                            scope.$apply();
                        }, 50);
                    }
                }
            );

            element.find('input').on('focus',
                function () {
                    scope.isOpen = true;
                    scope.hasFocus = true;
                    scope.highlightItem = scope.ngModel;
                }
            );

            element.find('input').on('keydown',
                function (evt) {
                    /* jshint maxcomplexity:false */
                    scope.isOpen = true;
                    var index = 0;
                    switch (evt.keyCode) {
                        case 40: //ARROW DOWN
                            evt.preventDefault();
                            scope.isOpen = true;
                            if (scope.filteredList) {
                                if (scope.highlightItem) {
                                    index = scope.filteredList.indexOf(scope.highlightItem);
                                    if (index < scope.filteredList.length - 1) {
                                        index++;
                                    }
                                }
                                scope.highlightItem = scope.filteredList[index];
                                moveListTo(index);
                            }
                            break;

                        case 38: //ARROW UP
                            evt.preventDefault();
                            scope.isOpen = true;
                            if (scope.filteredList) {
                                if (scope.highlightItem) {
                                    index = scope.filteredList.indexOf(scope.highlightItem);
                                    if (index > 0 || (scope.idMatchItem && index > -1)) {
                                        index--;
                                    }
                                }
                                if (index === -1) {
                                    scope.highlightItem = scope.idMatchItem;
                                } else {
                                    scope.highlightItem = scope.filteredList[index];
                                }
                                moveListTo(index);
                            }
                            break;

                        case 13:
                            if (scope.highlightItem) { scope.selectItem(scope.highlightItem); }
                            break;
                    }

                    scope.$apply();
                }
            );

            function moveListTo(index) {
                //var index = i + 1;

                var list = element.find('ul')[0];
                var item = list.children[index];

                if (!item) { return; }

                //If we need to scroll up to find the item
                if (item.offsetTop < list.scrollTop) {
                    list.scrollTop = item.offsetTop;
                }

                //If we need to scroll down to find the item
                if (item.offsetTop + item.offsetHeight > list.scrollTop + list.clientHeight) {
                    list.scrollTop = item.offsetTop + item.offsetHeight - list.clientHeight;
                }
            }

            scope.open = function () {
                if (scope.ngDisabled) { return; }
                if (scope.inputText !== '') {
                    scope.isOpen = true;
                }

                filterData();
                //Timeout to wait for the DOM to render
                $timeout(
                    function () {
                        if (scope.isOpen) {
                            moveListTo(0);
                            if (scope.isSelected()) {
                                moveListTo(scope.filteredList.indexOf(scope.highlightItem));
                            }
                        }
                    }
                );

            };


            /**
             * Modal for creating entities quickly
             */
            scope.showCreateModal = function () {
                if (scope.entityCreate) {
                    modals.showModal(scope.entityCreate, scope.entityCreateCallback);
                }
            };

            /**
             * Modal for editing entities quickly
             */
            scope.showEditModal = function () {
                if (scope.entityEdit) {
                    modals.showModal(scope.entityEdit, scope.entityEditCallback);
                }
            };

            /**
             * Link to entity info [entityLink + '?id=' + selectedItemId]
             */
            scope.goToLink = function () {
                $state.transitionTo(scope.entityLink, { id: scope.ngModel[scope.idField] });
            };
        }
    }
})();